import { Events } from '@carvana/vdp-events';
import { useContext, useEffect } from 'react';
import UserContext from '~/context/common/UserContext';
import { EventDetail } from '~/contracts/vdp';
import { useEventElements } from '~/hooks/vdp';
import { useButtonHandler } from '~/hooks/vdp/cta';
import {
  addEventListeners,
  filterLocalEvents,
  removeEventListeners
} from '~/utilities/vdp/browserEvents';

export default function useEventListeners() {
  const getStarted = useButtonHandler();
  const { triggerFetchUserProfile } = useContext(UserContext);
  const eventElements = useEventElements();

  useEffect(() => {
    // Get Started
    const handleGetStarted = filterLocalEvents(() => {
      getStarted();
    });

    // User Profile
    const handleUserProfile = filterLocalEvents<number>(() => {
      triggerFetchUserProfile();
    });

    addEventListeners<CustomEvent<EventDetail>>(eventElements, [
      [Events.GetStarted, handleGetStarted],
      [Events.UserProfile, handleUserProfile]
    ]);

    return () => {
      removeEventListeners<CustomEvent<EventDetail>>(eventElements, [
        [Events.GetStarted, handleGetStarted],
        [Events.UserProfile, handleUserProfile]
      ]);
    };
  }, [eventElements, getStarted, triggerFetchUserProfile]);
}
